import { provideHttpClient, HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MainService {
  constructor(private http: HttpClient) { }
  private apiURL = environment.apiUrl;
  private httpConfig: any = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'x-api-key': environment.mainApiKey
    }),
    body: ""
  };
  
  private httpConfigForm: any = {
        headers: new HttpHeaders({
      'x-api-key': environment.mainApiKey
    }),
    body: ""
  };

  public getRequest = (api: string): Observable<any>  => {  
    return this.http.get(this.apiURL + api);
  }

  public deleteRequest = (api: string): Observable<any>  => {
    return this.http.delete(this.apiURL + api);
  }

  public postRequest = (model: any, api: string): Observable<any> => {
    this.httpConfig.body = JSON.stringify(model);
    return this.http.request("POST", this.apiURL + api, this.httpConfig);
  }

  public postRequestFormData = (form: FormData, api: string): Observable<any> => {
    this.httpConfigForm.body = form;
    console.log("form sended", this.httpConfigForm.body, form);
    let url = this.apiURL + api;
    return this.http.request("POST", url, this.httpConfigForm);
  }

    serializeObj(obj: any): string {
      try {
        const jsonString = JSON.stringify(obj);
        const base64 = btoa(encodeURIComponent(jsonString).replace(/%([0-9A-F]{2})/g, (match, p1) => {
            return String.fromCharCode(parseInt(p1, 16));
        }));
        
        return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
      } catch (e) {
      
        const emptyBase64 = btoa(encodeURIComponent(JSON.stringify({})).replace(/%([0-9A-F]{2})/g, (match, p1) => {
            return String.fromCharCode(parseInt(p1, 16));
        }));
        return emptyBase64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
      }
    }
    
    deserializeObj(obj: any): any {
      try {
        let base64 = obj.replace(/-/g, '+').replace(/_/g, '/');
        while (base64.length % 4) { base64 += '='; }
        const jsonString = decodeURIComponent(atob(base64).split('').map(c => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)).join(''));
        return JSON.parse(jsonString);
      } catch (e) {
        return {};
      }
    }
}